import { useRouter } from "found";
import * as React from "react";
import { useEffect } from "react";
import { RouteRenderer } from "../route-renderer";

/**
 * Outlook doesn't provide a way to differentiate between creating a new event and editing or viewing an existing event.
 * Checks for an event id via the Office API. If present, we arae loaded alongside an existing event. Redirect to OutlookExistingEvent.
 * If not present, we are creating a new event. Redirect to OutlookNewEvent.
 */
export const OutlookEventRouter = () => {
  const { router } = useRouter();

  useEffect(() => {
    // Must use window.Office.context.mailbox?.item?.itemId to get id while viewing an event,
    // and window.Office.context.mailbox?.item?.getItemIdAsync to get id while editing and existing event. Shrug.
    const itemId = window.Office.context.mailbox?.item?.itemId;
    if (itemId) {
      // Viewing an existing event.
      router.replace("/outlook/existing-event");
    }
    window.Office.context.mailbox?.item?.getItemIdAsync?.((result) => {
      if (result.status === window.Office.AsyncResultStatus.Succeeded) {
        // Editting an existing event.
        router.replace("/outlook/existing-event");
      } else {
        // Creating a new event.
        router.replace("/outlook/new-event");
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Perma-loading. Above useEffect will redirect to the correct page.
  return <RouteRenderer loading={true} error={false}></RouteRenderer>;
};
